export default "__VITE_ASSET__481yxupF__"